module.exports = __webpack_public_path__ + "media/components/country-flag/static/zw-8511668cb9726a523d3998cd83b2afa6.svg";